export const types = {
  REDIRECT_TO_NOT_FOUND: 'Errors/RedirectToNotFound',
  REDIRECT_TO_ACCESS_DENIED: 'Errors/RedirectToAccessDenied',
  CANCEL_REDIRECTS: 'Errors/CancelRedirects',
}

export function redirectToNotFound() {
  return {
    type: types.REDIRECT_TO_NOT_FOUND,
  }
}

export function redirectToAccessDenied() {
  return {
    type: types.REDIRECT_TO_ACCESS_DENIED,
  }
}

function cancelRedirects() {
  return {
    type: types.CANCEL_REDIRECTS,
  }
}

export default {
  redirectToNotFound,
  redirectToAccessDenied,
  cancelRedirects,
}